import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "../store";
import "nx-libs/configs";
import "@/configs/axios.config";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "./main.scss";
import MainContent from "./components/main/MainContent";
import VueI18n from "vue-i18n";
import VueMeta from "vue-meta";
import "./container";
import { getLocale } from "@/services/locale.service";
import { localize, localeChanged } from "vee-validate";
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import { AccessibilityMixin } from "@/mixins";
import Common from "@/utils/common";
import VueDOMPurifyHTML from "@/plugins/vue-dompurify-html.plugin";

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueI18n);
Vue.use(VueMeta);
Vue.use(VueDOMPurifyHTML);

// 全局注册Accessibility mixin
Vue.mixin(AccessibilityMixin);

Vue.prototype.$common = Common;

Vue.component("MainContent", MainContent);

const i18n = new VueI18n({
  locale: getLocale(),
  fallbackLocale: "en",
  messages: {
    en: {
      validations: {
        messages: {
          required: "The {_field_} is required"
        }
      }
    },
    zh_hk: {
      validations: {
        messages: {
          required: "{_field_} 為必填"
        }
      }
    },
    zh_cn: {
      validations: {
        messages: {
          required: "{_field_} 为必填"
        }
      }
    }
  }
});

extend('required', {
  ...required,
  // the values param is the placeholders values
  message: (_, values) => i18n.t('validations.messages.required', values)
});

localize(getLocale());
localeChanged();
/**
 * @nextore/commonLang
 */
import en from "@unify/common-lang/locales/en.json";
import zhHK from "@unify/common-lang/locales/zh_hk.json";
import zhCN from "@unify/common-lang/locales/zh_cn.json";

i18n.mergeLocaleMessage("en", en);
i18n.mergeLocaleMessage("zh_hk", zhHK);
i18n.mergeLocaleMessage("zh_cn", zhCN);

/**
 * @unify/v-help-pro
 */
import persistConfig from "@nextore/v-help-pro-config";
import { Plugin as VHelpProPlugin } from "@unify/v-help-pro";
import VHelpProLocaleEN from "@unify/v-help-pro/locales/en.json";
import VHelpProLocaleHK from "@unify/v-help-pro/locales/zh_hk.json";
import VHelpProLocaleCN from "@unify/v-help-pro/locales/zh_cn.json";
// import "@unify/v-help-pro/dist/index.css";
import HelpProView from "../pages-core/help-pro/views/HelpProView.vue";

// Vue.use(VHelpProPlugin, { router, store, persistConfig });

Vue.use(VHelpProPlugin, {
  router,
  store,
  // persistConfig,
  persistConfig: {
    async fetchHelp(id) {
      const noMoreShow = localStorage.getItem(`noMoreHelp_${id}`) === 'true';
      let helpId = id
      if (getLocale() == 'zh_hk') {
        helpId = id + "_hk";
      }
      else if (getLocale() == 'zh_cn') {
        helpId = id + "_cn";
      }
      try {
        const data = await axios.get(`/api/help-page?id=${helpId}`); // get the help item
        if (!data.data.id) {
          throw new Error('id is empty');
        }
        if (!data.data.details) {
          try {
            const data_en = await axios.get(`/api/help-page?id=${id}`); // get the help item
            if (!data_en.data.id) {
              throw new Error('id is empty');
            }
            return {
              // map the help item
              id: id,
              description: !noMoreShow ? data.data.description || '' : '',
              details: data_en.data.details || '',
              noMoreShow: data_en.data.noMoreShow,
            };
          } catch (ex) {
            console.warn("catch error", ex);
            return {
              id: id,
              description: '',
              details: '',
              noMoreShow: false,
            };
          }
        } else return {
          id: id,
          description: !noMoreShow ? data.data.description || '' : '',
          details: data.data.details || '',
          noMoreShow: data.data.noMoreShow,
        };
      } catch (ex) {
        console.warn("catch error", ex);
        return {
          id: id,
          description: '',
          details: '',
          noMoreShow: false,
        };
      }
    },
    // 保存|更新帮助信息
    async saveHelp(e) {
      localStorage.setItem(`noMoreHelp_${e.id}`, e.noMoreShow);
    }
  },
  templateConfig: {
    component: HelpProView,
    templateLink: `${process.env.BASE_URL}v-help-pro.html`, // point to the help pro window page
  },
});

i18n.mergeLocaleMessage("en", VHelpProLocaleEN);
i18n.mergeLocaleMessage("zh_hk", VHelpProLocaleHK);
i18n.mergeLocaleMessage("zh_cn", VHelpProLocaleCN);

/**
 * @unify/v-help-pro
 */
import '@nextore/common/dist/common.css';
import '@nextore/bd-common/dist/bd-common.css';
import { createApp, AppConfig, spinnerConfig } from '@nextore/common';
import { GlobalSpinner } from '@nextore/bd-common';
const config = new AppConfig();
config.use(spinnerConfig(GlobalSpinner));
 
createApp(App, {
  router,
  store,
  i18n,
  appConfig: config
}).then((app) => {
  // @ts-ignore
  app.$mount('#app');
});

